import { shareDataElementAction } from "@/redux/actions/shareDataElement"
import currentStatuses  from "@/constants/statuses"

const initialState = {
	dataElement: {},
	recipient: [],
	onBehalfOf: [],
	storeFor: null,
	referenceId: "",
	action: {type: "", value: ""},
	payload: [],
	attachments: [],
	requiredAttachments: [],
	participantsList: [],
	storeForList: [],
	onBehalfOfList: [],
	status: currentStatuses.not_started,
}

const shareDataElement = (state = initialState, action) => {
	switch (action.type) {
		case shareDataElementAction.SET_DATA_ELEMENT:
			return { ...state, dataElement: action.value };
		case shareDataElementAction.SET_RECIPIENT:
			return { ...state, recipient: action.value };
		case shareDataElementAction.SET_ON_BEHALF_OF:
			return { ...state, onBehalfOf: action.value };
		case shareDataElementAction.SET_STORE_FOR:
			return { ...state, storeFor: action.value };
		case shareDataElementAction.SET_REFERENCE_ID:
			return { ...state, referenceId: action.value };
		case shareDataElementAction.SET_ACTION:
			return { ...state, action: action.value };
		case shareDataElementAction.SET_PAYLOAD:
			return { ...state, payload: action.value };
		case shareDataElementAction.SET_ATTACHMENTS:
			return { ...state, attachments: action.value };
		case shareDataElementAction.SET_REQUIRED_ATTACHMENTS:
			return { ...state, requiredAttachments: action.value };
		case shareDataElementAction.SET_STATUS:
			return { ...state, status: action.value };
		case shareDataElementAction.SET_PARTICIPANTS_LIST:
			return { ...state, participantsList: action.value };
		case shareDataElementAction.SET_STORE_FOR_LIST:
			return { ...state, storeForList: action.value };
		case shareDataElementAction.SET_ON_BEHALF_OF_LIST:
			return { ...state, onBehalfOfList: action.value };
		case shareDataElementAction.UPDATE_STATE:
			return { ...state, ...action.value };
		case shareDataElementAction.RESET:
			return initialState;
		default:
			return state;
	}
}


export default shareDataElement;
